import React from 'react';

const useAsyncAction = (
	initialLoading = false
): [boolean, any, (action: () => Promise<void>) => Promise<void>, () => void] => {
	const [loading, setLoading] = React.useState(initialLoading);
	const [errorMessage, setErrorMessage] = React.useState<any>();

	// This fn cannot be called concurrently.
	const performAsyncAction = React.useCallback(async (action: () => Promise<void>) => {
		setLoading(true);
		setErrorMessage(undefined);
		try {
			await action();
		} catch (e: any) {
			setErrorMessage(e);
		} finally {
			setLoading(false);
		}
	}, []);

	// useful if we want to reset the error state before making another submission
	const clearError = React.useCallback(() => {
		setErrorMessage(undefined);
	}, []);

	return [loading, errorMessage, performAsyncAction, clearError];
};

export default useAsyncAction;
